import { render, staticRenderFns } from "./LevelingUp.vue?vue&type=template&id=3ac9ae3e&"
import script from "./LevelingUp.vue?vue&type=script&lang=ts&"
export * from "./LevelingUp.vue?vue&type=script&lang=ts&"
import style0 from "./LevelingUp.vue?vue&type=style&index=0&id=3ac9ae3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports